import Vue from "vue";
import ProductReviews from "./ProductReviews.vue";

new Vue({
  el: "#reviews-app",
  render: function (createElement) {
    return createElement(ProductReviews, {});
  },
});
